(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('errorModal', errorModal);

    /* @ngInject */
    function errorModal() {
        var directive = {
            bindToController: true,
            templateUrl: 'error-modal.tpl',
            controller: errorModalController,
            controllerAs: 'vm',
            link: link,
            restrict: 'C',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            //console.log(scope.vm.data);
        }
    }

    /* @ngInject */
    function errorModalController ($scope) {
        $scope.close = function() {
            angular.element('.overlay.active').removeClass('active');
            setTimeout(function() {
                $scope.$root.errorNoPies = false;
            }, 10);
        };

        $scope.yes = function() {
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $('.form-field[field-key="pies"] .content').parent().offset().top - 185
                }, 1);
            }, 100);
            $scope.close();
        };
        $scope.no = function() {
            $scope.$root.setFold('source');
            $scope.close();
        };
    }
})();